export default "__VITE_ASSET__2f74a410__"